import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const s = i(
  (e, a) => /* @__PURE__ */ o.jsx(
    l,
    {
      ref: a,
      ...e,
      image: (r) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...r,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M6 6h4V4a2 2 0 1 0-4 0zm6 0V4a4 4 0 0 0-8 0v2H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-5 7V9h2v4z",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
s.displayName = "LockIcon";
export {
  s as LockIcon,
  s as default
};
//# sourceMappingURL=index.js.map
